// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { Cart, updateCart as updateCartApi } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    ExecuteOnSuccessCallback,
    LoadCart,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import deleteWishList from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishList";
import { parseBoolean } from "@plumberssupply/XDL/Utilities";

export const UpdateCart: typeof LoadCart = async props => {
    if (!(props.parameter as any).jobName) {
        return;
    }

    const { cartId } = props.getState().pages.checkoutShipping;
    const cartState = cartId
        ? getCartState(props.getState(), cartId).value
        : getCurrentCartState(props.getState()).value;

    if (!cartState) {
        return;
    }

    const cart: Cart = {
        ...cartState,
        poNumber: (props.parameter as any).jobName,
        properties: {
            ...cartState.properties,
            plumbers_isSingleUse: (props.parameter as any).isSingleUse,
            plumbers_isSaved: (props.parameter as any).isSaved,
        },
    };

    await updateCartApi({
        cart: {
            ...cart,
        },
    });
};

export const DeleteSingleUseWishList = (props: any) => {
    if (!parseBoolean(props.parameter.isSingleUse)) {
        return;
    }
    props.dispatch(
        deleteWishList({
            wishListId: props.parameter.apiParameter.wishListId,
        }),
    );
};

addToChainBefore(chain, LoadCart, UpdateCart);
addToEndOfChain(chain, DeleteSingleUseWishList);
